import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { AuthUser } from "./auth.types";

type AuthState = {
	accessToken: string | null;
	refreshToken: string | null;
	user: AuthUser | null;
	setAuth: (payload: { accessToken: string; refreshToken: string; user: AuthUser }) => void;
	setTokens: (payload: { accessToken: string; refreshToken: string }) => void;
	setAccessToken: (accessToken: string | null) => void;
	clear: () => void;
};

export const useAuthStore = create<AuthState>()(
	persist(
		(set) => ({
			accessToken: null,
			refreshToken: null,
			user: null,
			setAuth: (payload) =>
				set({
					accessToken: payload.accessToken,
					refreshToken: payload.refreshToken,
					user: payload.user,
				}),
			setTokens: (payload) =>
				set((state) => ({
					accessToken: payload.accessToken,
					refreshToken: payload.refreshToken,
					user: state.user,
				})),
			setAccessToken: (accessToken) => set({ accessToken }),
			clear: () => set({ accessToken: null, refreshToken: null, user: null }),
		}),
		{ name: "auth-storage" },
	),
);

export const waitForAuthHydration = () => {
	if (useAuthStore.persist.hasHydrated()) return Promise.resolve();
	return new Promise<void>((resolve) => {
		const unsub = useAuthStore.persist.onFinishHydration(() => {
			unsub();
			resolve();
		});
	});
};
